module.exports = __webpack_public_path__ + "static/img/login-left-bottom.fb7b049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/login/login-left-bottom.png
// module id = BR8n
// module chunks = 1